import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-gamepad-line text-lg"></i>
            </div>
            <span className="font-heading text-xl text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              黄油游戏大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/rpg"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              游戏分类
            </Link>
            <Link
              to="/article/top-rpg-games-2025"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/article')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              游戏攻略
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索游戏..."
                className="pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100/50 w-48 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden border-t border-background-200 py-4">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              <Link
                to="/category/rpg"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.startsWith('/category')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                游戏分类
              </Link>
              <Link
                to="/article/top-rpg-games-2025"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.startsWith('/article')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                游戏攻略
              </Link>
              <Link
                to="/about"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive('/about')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
              <div className="px-4 pt-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索游戏..."
                    className="pl-9 pr-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 w-full transition-all"
                  />
                  <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}